import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authHeadersInterceptor } from './auth-header.interceptor';
import { AuthSessionService } from './auth-session.service';

export function provideAuthSession(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideHttpClient(withInterceptors([authHeadersInterceptor])),
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (authSessionService: AuthSessionService) => () =>
        authSessionService.restoreFromStorage(),
      deps: [AuthSessionService]
    }
  ]);
}
